import { useTranslation } from 'react-i18next'

import { Description, List, Flare, Timeline } from '@mui/icons-material'

export enum EventDialogTab {
  Description = 'Description',
  Instances = 'Instances',
  AllEvents = 'AllEvents',
  LiveEventEvolution = 'LiveEventEvolution',
}

export const DEFAULT_EVENT_DIALOG_TAB = EventDialogTab.AllEvents

const eventDialogTabs: string[] = Object.values(EventDialogTab)

/**
 * The dialog tab a URL asks for, or the default one when the value is missing
 * or names a tab that no longer exists (old links to the removed "OtherGames"
 * tab would otherwise open the dialog with no panel at all).
 */
export const resolveEventDialogTab = (tab?: string | null): EventDialogTab =>
  tab && eventDialogTabs.includes(tab) ? (tab as EventDialogTab) : DEFAULT_EVENT_DIALOG_TAB

export const useEventDialogTabs = () => {
  const { t } = useTranslation()

  const allTabs = [
    {
      id: EventDialogTab.Description,
      label: t('live-events:event_dialog_tab_description'),
      icon: <Description />,
      tooltip: t('live-events:event_dialog_tab_description_tooltip'),
    },
    {
      id: EventDialogTab.Instances,
      label: t('live-events:event_dialog_tab_instances'),
      icon: <Flare />,
      tooltip: t('live-events:event_dialog_tab_instances_tooltip'),
    },
    {
      id: EventDialogTab.LiveEventEvolution,
      label: t('live-events:blueprint'),
      icon: <Timeline />,
      tooltip: t('live-events:event_dialog_tab_evolution_tooltip'),
    },
    {
      id: EventDialogTab.AllEvents,
      label: t('live-events:event_dialog_tab_all_events'),
      icon: <List />,
    },
  ]

  return allTabs
}
